import { motion } from 'framer-motion';
import {
  MATCH_ENTRY_FEE,
  SEASON_POINTS_CLEAN_WIN,
  SEASON_POINTS_DRAW,
  SEASON_POINTS_LOSS,
  SEASON_POINTS_WIN,
} from '@elmental/shared';
import { useGameStore } from '../stores/gameStore';
import { ArrowLeftIcon } from '../components/icons/ArrowLeftIcon';
import { GameModeInfoSection } from '../components/GameModeInfoSection';
import { HowToPlaySection } from '../components/HowToPlaySection';
import { currencyForUser, formatCurrencyAmount } from '../services/economy';

const REWARD_PREVIEW = [
  { label: 'Clean Win', value: SEASON_POINTS_CLEAN_WIN },
  { label: 'Win', value: SEASON_POINTS_WIN },
  { label: 'Draw', value: SEASON_POINTS_DRAW },
  { label: 'Play', value: SEASON_POINTS_LOSS },
];

export function InformationScreen() {
  const { telegramUser, setScreen } = useGameStore();
  const currency = currencyForUser(telegramUser);

  return (
    <div className="game-home-stage flex flex-col h-full overflow-y-auto scrollbar-hide">
      <div className="flex flex-col gap-4 p-4 pb-7">
        <div className="flex items-center gap-3">
          <button
            data-nav
            className="w-9 h-9 rounded-xl flex items-center justify-center"
            aria-label="Back to home"
            style={{ background: 'oklch(21% 0.045 252 / 0.9)', border: '1px solid oklch(43% 0.055 252 / 0.72)', boxShadow: '0 8px 18px oklch(3% 0.02 252 / 0.42)' }}
            onClick={() => setScreen('home')}
          >
            <ArrowLeftIcon size={18} className="text-text-secondary" />
          </button>
          <h1 className="text-xl font-black text-text-primary">Information</h1>
        </div>

        <motion.div
          className="arena-page-section"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <GameModeInfoSection />
        </motion.div>

        <motion.div
          className="arena-page-section"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.05 }}
        >
          <HowToPlaySection />
        </motion.div>

        <motion.div
          className="arena-page-section"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
        >
          <div className="arena-section-label mb-3">
            Season Points
          </div>

          <div className="flex items-center justify-between gap-3 rounded-xl border px-3 py-3"
            style={{ borderColor: 'oklch(76% 0.026 86 / 0.16)', background: 'oklch(8% 0.03 252 / 0.58)' }}
          >
            <div className="text-xs font-semibold tracking-widest uppercase text-text-secondary">
              Match entry
            </div>
            <div className="text-sm font-black text-gold">
              {formatCurrencyAmount(MATCH_ENTRY_FEE, currency)}
            </div>
          </div>

          <div className="mt-3 grid grid-cols-2 gap-2">
            {REWARD_PREVIEW.map((reward) => (
              <div
                key={reward.label}
                className="arena-reward-chip px-3 py-2"
              >
                <div className="text-base font-black text-energy-high">+{reward.value}</div>
                <div className="text-[11px] font-semibold text-text-secondary">{reward.label}</div>
              </div>
            ))}
          </div>

          <div className="mt-4 rounded-xl border px-3 py-3 text-xs font-semibold leading-snug text-text-secondary"
            style={{ borderColor: 'oklch(76% 0.026 86 / 0.14)', background: 'oklch(18% 0.044 72 / 0.42)' }}
          >
            {currency} opens matches. Season Points are earned from play and do not come from the opponent balance.
          </div>
        </motion.div>
      </div>
    </div>
  );
}
